import React from 'react';
import UserAuthWrapper from './UserAuthWrapper';

interface AdminAuthWrapperProps {
    children: React.ReactNode;
}

const AdminAuthWrapper: React.FC<AdminAuthWrapperProps> = ({children}) => {
    return (
        <UserAuthWrapper
            userType="admin"
            tableName="admin_users"
            redirectPath="/dashboard"
            clearPasswordResetFunction="clear_admin_password_reset"
        >
            {children}
        </UserAuthWrapper>
    );
};

export default AdminAuthWrapper;
